<template>
  <v-col >
    <v-row no-gutters v-for="(it, index) in mapVal" :key="index">
      <p
      v-if='!mapKey[index].startsWith("id_") &&
          mapKey[index] != "createdAt" &&
          mapKey[index] != "id" &&
          mapKey[index] != "updatedAt" &&
          mapKey[index] != "incidencia" &&
          mapKey[index] != "Familias Material" &&
          mapKey[index] != "Tareas" &&
          mapKey[index] != "ser_ped"'
          class="p-row">
        {{ capitalizeFirst(mapKey[index]) }}: {{ formatItem(mapKey[index],mapVal[index]) }}
      </p>
    </v-row>
  </v-col>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      detailItem: {},
      mapKey: [],
      mapVal: [],
    };
  },
  mounted() {
    this.getItem()
    this.mapKey = Object.keys(this.detailItem);
    this.mapVal = Object.values(this.detailItem);
  },
  props: {
    headers: Array,
    item: Object,
  },
  methods: {
    getItem(){
      var item = this.item
      this.detailItem = item
    },
    parseFecha(fecha) {
      var m = new Date(fecha);
      var nf =
        ("0" + m.getUTCDate()).slice(-2) +
        "/" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "/" +
        m.getUTCFullYear()
      return nf;
    },
    capitalizeFirst(str) {
      var c = str.charAt(0).toUpperCase() + str.slice(1);
      var final = c
      if(c.includes('_')){
        final = c.split('_')[0] + ' ' + c.split('_')[1]
      }
      return final
    },
    formatItem(key, value) {
      if (key == "fecha_entrega" || key == "fecha_pedido") {
        return this.parseFecha(value)
      } else if(key == "id"){
        return value
      }else if(key == "user"){
        if(value != undefined && value != null){
          return value.username
        }else{
          return "Sin asignar"
        }
      } else if(key=="Prioridad"){
        return value.nombre
      } else if(key=="cliente"){
        return value.nombre1
      } else if(key=="familia_material"){
        return value.nombre
      } else if(key=="usuario" && value != null){
        return value.nombre + "(" + value.email + ")"
      } else if(key=="estado"){
        return value.nombre
      } else if(key=="nivel" || key=="cantidad" || key=="ser_ped"){
        return value
      } else if (value == true) {
        return 'Sí'
      } else if (value == false) {
        return 'No'
      } else if(value == '' || value == undefined || value == null){
        return "Sin determinar";
      } else if(Array.isArray(value)){
        return value[value.length-1]
      }else{
        return value
      }
    },
  },
};
</script>
<style>
.p-row {
  width: fit-content;
  height: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/table/old/DetailRowOld.vue